/**
 * Header for a plate block: a foil-ringed icon, a small spaced eyebrow and a
 * Bodoni title. Mirrors the verification plate so every block reads as one set.
 */
export default function PlateHeader({ icon, eyebrow, title, subtitle, aside, className = '' }) {
  return (
    <div className={`mb-6 flex items-center gap-4 ${className}`}>
      {icon && (
        <span
          className="flex h-[52px] w-[52px] shrink-0 items-center justify-center rounded-full bg-m1-foil p-px"
          aria-hidden="true"
        >
          <span className="flex h-full w-full items-center justify-center rounded-full bg-m1-surface text-[22px] text-m1-violet">
            {icon}
          </span>
        </span>
      )}
      <div className="min-w-0 flex-1">
        {eyebrow && (
          <p className="text-[13px] uppercase tracking-[0.18em] text-m1-muted">{eyebrow}</p>
        )}
        <h3 className="mt-1 font-m1-display text-[clamp(22px,2.4vw,28px)] font-normal leading-tight tracking-[-0.01em] text-m1-ink">
          {title}
        </h3>
        {subtitle && <p className="mt-1 text-[15px] font-light text-m1-muted">{subtitle}</p>}
      </div>
      {aside && <div className="shrink-0">{aside}</div>}
    </div>
  )
}
